
  export default {
    name: 'Theme2MissionTermAndConditionDialog',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      isMission: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      modal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      exchangeRewardTermAndCondition() {
        if (this.isMission) {
          return this.$store.state.activities?.['mission-reward']?.mission?.tnc
        }
        return this.$store.state.activities['exchange-reward'].exchangeRewardTermAndCondition
      }
    }
  }
